"use strict";

import secureLinkContent from "./utils/secureLinkContent.js";

let SecurePhone = {
    options: {
        selector: 'a[class="secure-phone"]',
    },
};

SecurePhone.init = function (userOptions) {
    for (const prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

SecurePhone.initSelectors = function (rootElement) {
    const elements = rootElement.querySelectorAll(this.options.selector);

    elements.forEach(function (element) {
        if (element.hasOwnProperty('moduleSecurePhoneInitialized')) { return; }
        element.moduleSecurePhoneInitialized = true;

        const first = element.getAttribute("data-zone");
        const second = element.getAttribute("data-sub-zone");
        const end = element.getAttribute("data-end");
        const icon = element.getAttribute("data-icon");
        let prefix = element.getAttribute("data-prefix");
        if (!prefix) {
            prefix = "420";
        }
        element.setAttribute("href", "tel:+" + prefix + first + second + end);
        element.replaceChildren(...secureLinkContent(icon, "+" + [prefix, first, second, end].join(" ")));
    });
}

export {SecurePhone};